import { useTranslation } from 'react-i18next';
import type { IBiKpisProps } from './IBiKpisProps';

/**
 * Показники бізнес-аналітики (прототип v4 G:L1700): картки minmax(120px, 1fr), радіус 12 — підпис 11px великими літерами, значення 30px/300
 * (записи — чорнило, відкрито — синій, прострочено — помаранчевий, виконано — зелений, учасники — фіолетовий), примітка 12px.
 */
export function BiKpis({ stats, modules, members }: IBiKpisProps) {
  const { t } = useTranslation();
  const kpi = (key: string, label: string, value: number | undefined, tone: string, note = '') => (
    <div key={key} className="bi-kpi">
      <span className="bi-kpi__label">{label}</span>
      <span className="bi-kpi__value" style={{ color: tone }}>{value ?? '—'}</span>
      <span className="bi-kpi__note">{note}</span>
    </div>
  );
  return (
    <div className="bi-kpis">
      {kpi('records', t('biPage.kpiRecords'), stats?.records, 'var(--ink)', t('shell.modulesCount', { count: modules }))}
      {kpi('open', t('biPage.kpiOpen'), stats?.open, 'var(--bi-blue)')}
      {kpi('overdue', t('biPage.kpiOverdue'), stats?.overdue, stats?.overdue ? 'var(--bi-orange)' : 'var(--muted)')}
      {kpi('done', t('biPage.kpiDone'), stats?.done30, 'var(--bi-green)')}
      {kpi('members', t('biPage.kpiMembers'), members, 'var(--bi-purple)')}
    </div>
  );
}
